module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "stories"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("Telling Stories")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "h2sub"
  }, [_vm._v("Lee Lauderback")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("S")]), _vm._v("tories are treasures that have had significant impact on human history. Without stories, history is lost. Stories involve real people, their exploits, their failures, and their accomplishments. Storytelling has existed since primitive man. Paintings on the walls of caves that date back thirty-five thousand years tell of life-changing events that were shared with others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In September 1940, the first P-51 took to the skies, and a storybook of epic proportions followed. But now, nearly seventy-five years later, the chapter on these courageous men who flew this magnificent fighter in combat is rapidly closing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have been privileged to fly the P-51 Mustang almost every day for the past twenty-five years, but the real blessing has been to share the Mustang once again with some of the warriors who flew the aircraft for real, and listen to their stories.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men such as Irving Reedy, whose last combat mission was in March 1944, a fateful day when he was shot down by enemy ground fire and became a prisoner of war. Nearly fifty-six years later, we flew the Mustang together one last time. It was a special flight, but even more special was to listen to his stories of flying the P-51 in combat. The facts had little if any emotion, while his stories make his history very real.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("Or the legendary Robin Olds, the “Break glass in case of war” leader who flew the P-51 in combat and quickly became an ace. I had the privilege to requalify Robin almost twenty years ago in "), _c('em', [_vm._v("Scat VII")]), _vm._v(", a TF-51 Mustang. We had an awesome time, but even more special was the chance to hear some of his stories of flying the Mustang; to hear how he precisely maneuvered his nimble Mustang to defeat enemy aircraft; to hear how the Mustang always brought him back from combat; to hear how "), _c('em', [_vm._v("Scat")]), _vm._v(" became the name on all his combat aircraft.")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Or the very best stick and rudder man ever to fly, R. A. “Bob” Hoover, the “pilot’s pilot.” Over the years I’ve had the privilege to fly with Bob many times, and each was an adventure. However, the real treasure was an exclusive invite to drink gin and vodka while listening to Bob and Tex Hill tell stories on each other. If I’d only had a recorder!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jim Brooks, Buck and Bill Patttillo, Bud Anderson, Joe Peterburs, Bruce Carr, and many others have unique stories that have been shared with me over the years. These are stories that I have never written down or really even shared with others, but were permanently carved in my memory. Special times, special places, special pilots, special people!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are my stories, but there are other incredible stories to be told, and "), _c('em', [_vm._v("The Fight in the Clouds")]), _vm._v(" collects extraordinary accounts of other warriors and their missions in different models of the P-51 Mustang. These are accurate stories, well researched and unembellished, that take you into combat with these brave young fighter pilots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark Twain once said, “I do not claim that I can tell a story as it ought to be told. I only claim to know how a story ought to be told.” My good friend Jim Busha must have taken notes from Mr. Twain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So find your most comfortable chair, pour your favorite beverage, and share the cockpit with some of the pilots who made the P-51 Mustang a legendary fighter.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Mustangs forever,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Lee Lauderback")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('em', [_vm._v("Lee Lauderback is president and CEO of Stallion 51 Corporation, located at the Kissimmee Gateway Airport, Florida. Stallion 51’s innovative and comprehensive curriculums have instructed thousands of pilots on the correct and safe methods of flying both the legendary P-51 Mustang and the historic T-6 Texan for the past twenty-five years.")])])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Lee has been the chief flight instructor since Stallion 51’s inception, amassing over 20,000 flight hours in all types of aircraft, including over 8,700 hours in the P-51 Mustang. Lee is the world’s highest-time P-51 Mustang pilot.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg",
      "width": "25%"
    }
  })])]), _c('p', {
    staticClass: "centercap"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('strong', [_vm._v("Stallion 51")]), _c('br')]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.stallion51.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stallion51.com")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-02.jpg",
      "width": "25%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "centercap"
  }, [_c('strong', [_vm._v("Stallion 51 P-51 Photographs")]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93b02dfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/stories.vue
// module id = 66
// module chunks = 0